const SELECT_URL_KEY = 'microPaySelectUrl'

/** 后端 PaySiteUrl 常是正式域名；页面已在本地/预发时，跳转保持当前 origin */
export function keepCurrentOrigin (url) {
  if (!url) return ''
  try {
    const u = new URL(url, window.location.origin)
    return window.location.origin + u.pathname + u.search + u.hash
  } catch (e) {
    return url
  }
}

export function saveMicroSelectUrl (url) {
  try {
    const next = keepCurrentOrigin(url) || url
    if (next) sessionStorage.setItem(SELECT_URL_KEY, next)
  } catch (e) { /* ignore */ }
}

export function clearMicroSelectUrl () {
  try { sessionStorage.removeItem(SELECT_URL_KEY) } catch (e) { /* ignore */ }
}

export function getMicroSelectUrl () {
  try {
    return sessionStorage.getItem(SELECT_URL_KEY) || ''
  } catch (e) {
    return ''
  }
}

export function applyMicroSelectUrl (res) {
  const fromApi = res && (res.selectUrl || res.SelectUrl)
  const canSwitch = res && (res.canSwitchMerchant === true || res.CanSwitchMerchant === true)
  const noSwitch = res && (res.canSwitchMerchant === false || res.CanSwitchMerchant === false)
  if (canSwitch && fromApi) {
    saveMicroSelectUrl(fromApi)
    return getMicroSelectUrl() || keepCurrentOrigin(fromApi) || ''
  }
  if (noSwitch) {
    clearMicroSelectUrl()
    return ''
  }
  if (fromApi) {
    saveMicroSelectUrl(fromApi)
    return getMicroSelectUrl() || keepCurrentOrigin(fromApi) || ''
  }
  return getMicroSelectUrl() || keepCurrentOrigin(fromApi) || ''
}

export function goHubWithToken (token) {
  if (!token) return
  window.location.replace(`${window.location.origin}/hub/${token}`)
}
